// eslint-disable-next-line
const getHeaders = (apiKey: string, extraHeaders: any) => {
  // eslint-disable-next-line
  const headers: any = {};

  headers["content-type"] = "application/json";
  headers["x-api-key"] = apiKey;
  headers["content-type"] = "application/json";
  headers["accept"] = "application/json";

  if (extraHeaders) {
    Object.keys(extraHeaders).forEach((key: string) => {
      headers[key] = extraHeaders[key];
    });
  }

  return headers;
};

const api = (URL: string) =>
  Object.freeze({
    create: async (
      path: string,
      // eslint-disable-next-line
      request: any = null,
      apiKey: string,
      // eslint-disable-next-line
      extraHeaders?: any
    ) => {
      try {
        const target = URL + path;

        // eslint-disable-next-line
        const options: any = {
          method: "POST",
          headers: getHeaders(apiKey, extraHeaders),
        };

        if (request) {
          options.body = JSON.stringify(request);
        }

        const response = await fetch(target, options);
        const data = await response.json();

        return data;
      } catch (error) {
        console.error("error:", error);
      }
    },

    // eslint-disable-next-line
    createFormEncoded: async (path: string, request: any, apiKey: string) => {
      try {
        const target = URL + path;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options: any = {
          method: "POST",
          headers: {
            "x-api-key": apiKey,
            "content-type": "application/x-www-form-urlencoded",
          },
        };

        if (request) options.body = request;

        const response = await fetch(target, options);
        const data = await response.json();

        return data;
      } catch (error) {
        console.error("error:", error);
      }
    },

    // eslint-disable-next-line
    find: async (path: string, apiKey: string, extraHeaders?: any) => {
      try {
        const target = `${URL + path}`;
        // eslint-disable-next-line
        const options: any = {
          method: "GET",
          headers: getHeaders(apiKey, extraHeaders),
        };

        const response = await fetch(target, options);
        const data = await response.json();

        return data;
      } catch (error) {
        console.error("error:", error);
      }
    },
    // eslint-disable-next-line
    findById: async (path: string, apiKey: string, extraHeaders?: any) => {
      try {
        const target = URL + path;

        // eslint-disable-next-line
        const options: any = {
          method: "GET",
          headers: getHeaders(apiKey, extraHeaders),
        };

        const response = await fetch(target, options);
        const data = await response.json();

        return data;
      } catch (error) {
        console.error("error:", error);
      }
    },

    updateById: async (
      path: string,
      // eslint-disable-next-line
      request: any = null,
      apiKey: string,
      // eslint-disable-next-line
      extraHeaders: any
    ) => {
      try {
        const target = URL + path;

        // eslint-disable-next-line
        const options: any = {
          method: "PATCH",
          headers: getHeaders(apiKey, extraHeaders),
        };

        if (request) {
          options.body = JSON.stringify(request);
        }

        const response = await fetch(target, options);
        const data = await response.json();

        return data;
      } catch (error) {
        console.error("error:", error);
      }
    },

    // eslint-disable-next-line
    upsert: async (path: string, request?: any) => {
      try {
        const target = URL + path;

        // eslint-disable-next-line
        const options: any = {
          method: "PUT",
          headers: {
            "content-type": "application/json",
          },
        };

        if (request) {
          options.body = request;
        }

        const response = await fetch(target, options);
        const data = await response.json();

        return data;
      } catch (error) {
        console.error("error:", error);
      }
    },

    deleteById: async (path: string) => {
      try {
        const target = URL + path;
        // eslint-disable-next-line
        const options: any = {
          method: "DELETE",
          headers: {
            "content-type": "application/json",
          },
        };

        const response = await fetch(target, options);
        const data = await response.json();

        return data;
      } catch (error) {
        console.error("error:", error);
      }
    },
  });

export default api;
